import { CircularProgress, Grid, MenuItem, TextField } from '@material-ui/core';
import { compose } from 'recompose';
import { Context, ContextProvider } from './store';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import Snackbar from '../Snackbar';
import { useContext } from 'react';
import { PageTitle } from '../Subregions/blocks';
import { REPORTS } from './constants';
import { renderParameter } from './blocks';
import { PrimaryButton } from '@/styles/blocks';
import Table from '../Table';

const Reports = () => {
    const { state, loading, callbacks } = useContext(Context);

    return (
        <Grid
            container
            direction="column"
            css={css`
                height: 100%;
                background: ${colors.white.primary};
                flex-wrap: nowrap;
            `}
        >
            <Snackbar
                open={!!state.notification.message}
                {...state.notification}
                handleClose={() => callbacks.setNotification({})}
            />
            <Grid
                container
                css={css`
                    padding: 23px 45px;
                    border-bottom: 1px solid ${colors.greys[4]};
                    align-items: center;
                `}
            >
                <PageTitle>Reports</PageTitle>
                <Grid
                    item
                    css={css`
                        margin-left: 24px;
                        width: 300px;
                    `}
                >
                    <TextField
                        select
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Report Type"
                        value={state.reportType || ''}
                        onChange={(e) => callbacks.selectReport(e.target.value)}
                    >
                        {Object.entries(REPORTS).map(([key, { label }]) => (
                            <MenuItem key={key} value={key}>
                                {label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid
                    item
                    css={css`
                        margin-left: 24px;
                        width: 150px;
                    `}
                >
                    <PrimaryButton onClick={() => callbacks.generateReport()} disabled={!state.isValid}>
                        {state.data.length > 0 ? 'Refresh Report' : 'Generate Report'}
                    </PrimaryButton>
                </Grid>
                <Grid
                    item
                    css={css`
                        margin-left: 24px;
                        width: 150px;
                    `}
                >
                    <PrimaryButton
                        onClick={() => callbacks.exportReport()}
                        disabled={!state.isValid || !state.data.length}
                    >
                        Export Report
                    </PrimaryButton>
                </Grid>
            </Grid>
            {state.reportType ? (
                <Grid
                    container
                    css={css`
                        padding: 23px;
                        border-bottom: 1px solid ${colors.greys[4]};
                    `}
                >
                    {state.report.parameters.map((parameter) => (
                        <Grid
                            key={parameter.key}
                            item
                            css={css`
                                margin-left: 22px;
                                width: 300px;
                            `}
                        >
                            {renderParameter({
                                ...parameter,
                                value: state.parameters[parameter.key],
                                options: parameter.options || state.options[parameter.key],
                                onChange: (e) => callbacks.selectParameter(parameter.key, e.target.value),
                            })}
                        </Grid>
                    ))}
                </Grid>
            ) : null}
            <Grid
                container
                css={css`
                    flex-grow: 1;
                    align-items: center;
                    justify-content: center;
                `}
            >
                {loading.generate ? (
                    <CircularProgress size={200} color="primary" />
                ) : state.data.length > 0 && state.report ? (
                    <Table
                        data={state.data}
                        columns={[{ Header: 'Data', id: 'data', columns: state.report.columns }]}
                        callbacks={{
                            getRowId: state.report.getRowId,
                        }}
                        options={{
                            select: false,
                            sortAsync: false,
                            includeFooter: true,
                            topFooter: true,
                        }}
                    />
                ) : null}
            </Grid>
        </Grid>
    );
};

const withContext = (Component) => (props) =>
    (
        <ContextProvider>
            <Component {...props} />
        </ContextProvider>
    );

export default compose(withContext)(Reports);
